import { render, staticRenderFns } from "./mult.vue?vue&type=template&id=3b801708&"
import script from "./mult.vue?vue&type=script&lang=js&"
export * from "./mult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports